export const REDUCER_NAME = "nationalTeamSelector";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_NATIONALTEAMS = `${REDUCER_NAME}/SET_NATIONALTEAMS`;
